export default __webpack_public_path__ + "static/media/Group298.24f7678d.png";